export default __webpack_public_path__ + "static/media/css.d9bd7995.svg";